<div mat-dialog-title>
  <h2 [innerHTML]="'sanierung.introduction.headline.' + data.path + '.' + data.case | translate: placeholder"></h2>
  <button type="button" class="close" [mat-dialog-close]="true"  [aria-label]="'arialabel.close' | translate"><i class="icon-x"></i></button>
</div>
<mat-dialog-content>
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-6 large-7">
      <div class="callout lighter-gray" [innerHTML]="'sanierung.introduction.text.' + data.path + '.' + data.case | translate: placeholder"></div>
    </div>
    <div class="cell small-12 medium-6 large-5">
      <div class="chart-wrapper">
        <div aria-labelledby="first-bar-label first-bar-value" class="bar-wrapper" [style.height]="barFactor > 1? ((1 - (barFactor - 1)) * 100) + '%' : null">
          <div id="first-bar-value" [innerHTML]="(current | number: '1.0-0') + ('moderat.sanierung.unit.' + data.unit | translate)"></div>
          <span id="first-bar-label" [innerHTML]="'sanierung.introduction.diagram.aktuell' | translate"></span>
        </div>
        <div aria-labelledby="second-bar-label second-bar-value" class="bar-wrapper" [style.height]="barFactor < 1? (barFactor * 100) + '%' : null">
          <div id="second-bar-value" [innerHTML]="(sanitized | number: '1.0-0') + ('moderat.sanierung.unit.' + data.unit | translate)"></div>
          <span id="second-bar-label" [innerHTML]="'sanierung.introduction.diagram.saniert' | translate"></span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button type="button" [mat-dialog-close]="true" class="button primary inline-arrow-right" [innerHTML]="'sanierung.introduction.button' | translate"></button>
</mat-dialog-actions>
